import Registration from "components/Registration";
import IacstResults from "components/Result/IacstResults/result";
import PageNotFound from "components/404";
import ForgotPassword from "components/Login/ForgotPassword";
import Login from "components/Login/login";
import TermsandCondition from "components/terms/TermsandCondition";
import IacstEligibility from "staticPages/iACST-Eligibility";
import IacstResult from "staticPages/iACST-Result";
import IacstRegistration from "staticPages/iACST-Registration";

const publicRoutes = [
  { path: '/iacst-result', Component: IacstResults },
  { path: '/recover-credentials', Component: ForgotPassword },
  { path: '/iacst-scholarship/terms-conditions', Component: TermsandCondition },
  { path: '/404', Component: PageNotFound },
  { path: '*', Component: PageNotFound }
]

const host = window.location.hostname;
const isIACST =
  host === 'uat-iacst.aakash.ac.in' ||
  host === 'iacst.aakash.ac.in';

const authRoutes = [
  {
    path: '/',
    Component: isIACST ? Registration : Login,
    condition: (token) => token,
  },
  {
    path: '/exam/login',
    Component: Login,
    condition: (token) => token,
  },
  {
    path: '/iacstexam',
    Component: Registration,
    condition: (token) => token,
  },
  {
    path: '/iacst-exam',
    Component: Registration,
    condition: (token) => token,
  },
  {
    path: '/mock-neet-exam',
    Component: Registration,
    condition: (token, registration, registration_status) =>
      token && registration != 'success' && registration_status != 'failure',
  },
  {
    path: '/invictus',
    Component: Registration,
    condition: (token, registration, registration_status) =>
      token && registration != 'success' && registration_status != 'failure',
  },
  {
    path: '/mock-jee-exam',
    Component: Registration,
    condition: (token, registration, registration_status) =>
      token && registration != 'success' && registration_status != 'failure',
  },
]

const scholarshipRoutes = [
  {
    path: '/adst',
    Component: Registration,
    condition: (token) => token
  },
  {
    path: '/neet-repeater-scholarship',
    Component: Registration,
    condition: (token) => token
  },
  {
    path: '/iacst-medical-engineering-repeater-courses',
    Component: Registration,
    condition: (token) => token
  },
  {
    path: '/neet-repeater-scholarship-hindi',
    Component: Registration,
    condition: (token) => token
  },
  {
    path: '/jee-repeater-scholarship',
    Component: Registration,
    condition: (token) => token
  },
  {
    path: '/iacst-medical-engineering-repeater-courses-hindi',
    Component: Registration,
    condition: (token) => token
  },
  {
    path: '/iacst-eligibility',
    Component: IacstEligibility,
    condition: (token) => token
  },
  {
    path: '/iacst-result',
    Component: IacstResult,
    condition: (token) => token
  },
  {
    path: '/iacst-registration',
    Component: IacstRegistration,
    condition: (token) => token
  }
]

export { publicRoutes, authRoutes, scholarshipRoutes }